<div class="log" *transloco="let t; read:'permit.details.logs'">

    <div class="log__content">
        <div class="log__content__row">
              <div class="log__avatar" [class]="'log__avatar--' + log.permitLogEntryType"></div>
            <div class="log__content__text" [innerHTML]="t(transLocoString, {currentPersonFullName: getFullNameWithExtern(log), currentPersonRole: translateRoleEnum(log.currentPersonRole), targetPersonFullName: log.targetPersonFullName, targetPersonRole: translateRoleEnum(log.targetPersonRole)})"></div>
         <div class="log__content__date">{{ log.createdDate | haDate:"dateTimeStandard" }}</div>
        </div>
        <div class="log__content__row">
            <div class="log__content__date--mobile">{{ log.createdDate | haDate:"dateTimeStandard" }}</div>
        </div>
    </div>
</div>
